<script>
    import { onMount, onDestroy } from "svelte";
    import Select from "svelte-select/Select.svelte";
    import {
        Button,
        NotificationModal,
        PageLoading,
    } from "../../../Components/Common/index.svelte";
    import { apiMethods } from "../../../Services/index.svelte";

    import PatientDetailsSection from "./createEditSections/PatientDetailsSection.svelte";
    import PatientContactSection from "./createEditSections/PatientContactSection.svelte";
    import ProcedureDetailsSection from "./createEditSections/ProcedureDetailsSection.svelte";
    import InsuranceDetailsSection from "./createEditSections/InsuranceDetailsSection.svelte";
    import NotesDetailsSection from "./createEditSections/NotesDetailsSection.svelte";
    import {
        setInputFilter,
        getTodayWithTime,
        goToURL,
        goBack,
        showError,
        showException,
    } from "../../../Utils/utilFunctions.svelte";
    import {
        user,
        loggedInDoctorDetail,
        accountDoctors,
        prePopulateAccountOptions,
    } from "../../../stores";
    import {
        DirectInsuranceType,
        defaultState,
    } from "../../../Utils/utilEnums.svelte";
    import { NoteTypes } from "../../../Utils/utilConstants.svelte";
    import { addErrorInput } from "../helpers/encounterUtils.svelte";
    import {
        checkOpvContainsReciprocalHealthCareAgreement,
        resetIrrelevantInsuranceDetails,
        syncLabourEpiduralPatientTitleAndGender,
    } from "../helpers/encounterHelper.svelte";
    import { cacheAccountPrePopulateSearchOptions } from "../../../Utils/utilCache.svelte";
    import { convertWrongDateFormat } from "../../../Components/Custom/DateInput/date-utils";
    import CardLayout from "../../../Components/Common/CardLayout.svelte";
    import PreOpDetailsSection from "./createEditSections/PreOpDetailsSection.svelte";
    import OtherDetailsSection from "./createEditSections/OtherDetailsSection.svelte";

    export let params = {};
    export let updatePatientDetails = () => {};
    export let updatePatientEncounterDetails = () => {};

    export let isViewInDailyCalendarSidePanel = false,
        calendarSidePanelProps = {};

    let isLoadingAccount = false,
        isLoadingDoctor = false,
        isCreatingPatientEncounter = false,
        patientDetails = {
            source: "WebApp",
            sex: 2,
            alerts: "",
            notes: "",
            state: defaultState,
            patientContacts: [],
        },
        patientEncounterDetails = {
            source: "WebApp",
            procedureName: "",
            lengthInHours: 0.25,
            billingStatus: 0,
            scheduledDate: null,
            neuraxialType: Number(0),
            typeOfBill: Number(0),
            notes: "",
        },
        selectedDoctorProvider = {},
        insuranceDetails = {},
        selectedSurgeon = {},
        selectedHospital = {},
        adminSelectedAccount = {},
        createSurgeonFilters = { state: defaultState };

    let isOpvSuggestionsAttempt = false,
        isHealthFundFailed = false,
        isShowOverrideModal = false;

    let workerCompensation,
        workerCompensationObj = {};

    let trafficAuthority,
        trafficAuthorityObj = {};
    
    let defenceDataObj = {};

    let publicInPrivateObj = {};

    let thirdPartyPayerObj = {};

    let isEnterFromCalendar = false;
    let isCreateFromCalendarEvent = false;

    let errorFields = [];

    let showSaveWithoutValidations = false;

    let patientSectionRef,
        patientContactRef,
        procedureDetailsRef,
        insuranceDetailsRef,
        preOpDetailsRef,
        surgeonDetailsRef;

    let patientContactDetails = { useAsContact: false };

    let reciprocalHealthCareAgreementNotificationModalOpen = false,
        isChangingInsuranceTypeToOverseas = false;

    // if set TRUE then no validation check on submission
    let overrideValidation = false;

    $: isLoading = isLoadingDoctor;

    $: isFlowEnableSearchDoctor =
        $user.role == 100 || $user.role == 80 || $user.role == 20;

    $: if (patientDetails.insuranceType == 15) {
        const patientMedicareNoField = document.getElementById(
            "patientMedicareNoField",
        );
        const patientMedicareRefNoField = document.getElementById(
            "patientMedicareRefNoField",
        );
        if (patientMedicareNoField) {
            patientMedicareNoField.style.outline = "";
            patientMedicareNoField.placeholder = "Medicare No.";
        }
        if (patientMedicareRefNoField) {
            patientMedicareRefNoField.style.outline = "";
            patientMedicareRefNoField.placeholder = "Medicare Ref No.";
        }
    } else updateInputFields();

    $: isValidPatientContact = _checkPatientContactValidation(
        patientContactDetails,
    );

    $: showSelectAccountPhase =
        isFlowEnableSearchDoctor &&
        !adminSelectedAccount.id &&
        !isEnterFromCalendar &&
        !isCreateFromCalendarEvent &&
        !isViewInDailyCalendarSidePanel;

    $: if (showSelectAccountPhase) {
        window.addEventListener("keypress", _handleKeyboardPress);
    } else window.removeEventListener("keypress", _handleKeyboardPress);

    onMount(() => {
        if(params.createProps) {
            //it's from calendar event add encounter
            if(params.createProps.doctorId){
                loadDoctor(params.createProps.doctorId);
            } 

            if(params.createProps.scheduledDate) {
                patientEncounterDetails.scheduledDate = convertWrongDateFormat(params.createProps.scheduledDate[0]);
                patientEncounterDetails.scheduledTime = params.createProps.scheduledDate[1];
            }

            if(params.createProps.surgeonId) {
                selectedSurgeon.details = { id: params.createProps.surgeonId };
            }

            if(params.createProps.hospital) {
                selectedHospital.details = params.createProps.hospital;
            }

            isCreateFromCalendarEvent = true;
            
        }
        if (params && params.calendarQuery) {
            const paramsArr = params.calendarQuery.split("&");
            const doctorID = paramsArr
                .find((param) => param.includes("doctorID"))
                .split("=")[1];
            // const scheduleDate = paramsArr
            //     .find((param) => param.includes("dateStr"))
            //     .split("=")[1];
            const scheduleDateArr = paramsArr
                .find((param) => param.includes("dateStr"))
                .split("=")[1]
                .split("T");
            const dischargeDate = paramsArr
                .find((param) => param.includes("toDateStr"))
                .split("=")[1];

            loadDoctor(doctorID);

            patientEncounterDetails.scheduledDate = scheduleDateArr[0];
            patientEncounterDetails.scheduledTime = scheduleDateArr[1];

            if (dischargeDate) {
                patientEncounterDetails.dischargeDate = dischargeDate[0];
                patientEncounterDetails.dischargeTime = dischargeDate[1];
            }

            isEnterFromCalendar = true;
        } else if (
            !isFlowEnableSearchDoctor &&
            $user.id &&
            !$loggedInDoctorDetail.id
        )
            loadAccountByUserID($user.id);
        else if (isViewInDailyCalendarSidePanel)
            loadDoctor(calendarSidePanelProps.doctorID);

        setTimeout(() => {
            updateInputFields();
        }, 1000);

        if (isViewInDailyCalendarSidePanel) {
            patientEncounterDetails.scheduledDate =
                calendarSidePanelProps.startDate;
            patientEncounterDetails.scheduledTime = `${calendarSidePanelProps.startTime}:00`;

            patientEncounterDetails.dischargeDate =
                calendarSidePanelProps.endDate;
            patientEncounterDetails.dischargeTime = `${calendarSidePanelProps.endTime}:00`;
        } else if (!isEnterFromCalendar && !isCreateFromCalendarEvent)
            patientEncounterDetails.scheduledDate = null; //leave it as null for normal create encounter flow
    });

    onDestroy(() => {
        if (isFlowEnableSearchDoctor) {
            $loggedInDoctorDetail = {};
            $accountDoctors = [];
        }
    });

    const loadAccounts = async (filterText) => {
        isLoadingAccount = true;

        await cacheAccountPrePopulateSearchOptions();

        if (!filterText)
            return $prePopulateAccountOptions.length
                ? $prePopulateAccountOptions
                : [];

        return $prePopulateAccountOptions.length
            ? $prePopulateAccountOptions.filter(({ value }) =>
                  value.toLowerCase().includes(filterText.toLowerCase()),
              )
            : [];
    };

    const loadDoctor = async (id) => {
        isLoadingDoctor = true;

        await apiMethods.getMethod.getAccountById(id).then((res) => {
            if (res.id) {
                $loggedInDoctorDetail = { ...res };
                patientEncounterDetails.claimDelayHours = Number(
                    res.claimDelayHours,
                );
            }
        });

        isLoadingDoctor = false;
    };

    const loadAccountByUserID = (id) => {
        isLoadingDoctor = true;
        apiMethods.getMethod
            .getAccountByUserId(id)
            .then((res) => {
                if (res.id) {
                    $loggedInDoctorDetail = { ...res };
                    patientEncounterDetails.claimDelayHours = Number(
                        res.claimDelayHours,
                    );
                }
            })
            .then(() => (isLoadingDoctor = false));
    };

    const updateInputFields = () => {
        setInputFilter(
            document.getElementById("patientMedicareNoField"),
            function (value) {
                return value ? /^[0-9-\s]+$/i.test(value) : true;
            },
            "Must be an integer",
        );

        setInputFilter(
            document.getElementById("patientMedicareRefNoField"),
            function (value) {
                return value ? /^[0-9]+$/.test(value) : true;
            },
            "Must be an integer",
        );

        setInputFilter(
            document.getElementById("insuranceDetailsMembershipNoField"),
            function (value) {
                return value ? /^[A-z0-9]+$/.test(value) : true;
            },
            "Must be either an integer or a character",
        );

        setInputFilter(
            document.getElementById("insuranceDetailsMembershipRefNoField"),
            function (value) {
                return value ? /^[0-9]+$/.test(value) : true;
            },
            "Must be an integer",
        );
    };

    const adminGoToCreatePatientEncounter = async () => {
        const accountId = adminSelectedAccount.selectedAccount.key;

        await apiMethods.getMethod.getAccountById(accountId).then((res) => {
            if (!res || res.error)
                showError(
                    "Failed to load selected doctor details, please refresh the page and try again and contact support if the issue persists.",
                );
            else {
                adminSelectedAccount = { ...res };
                $loggedInDoctorDetail = { ...res };
                patientEncounterDetails.claimDelayHours = Number(
                    res.claimDelayHours,
                );
            }
        });
    };

    const removeIrrelevantFields = async () => {
        const cleanUpDataObj = resetIrrelevantInsuranceDetails(
            patientDetails,
            insuranceDetails,
            workerCompensation,
            workerCompensationObj,
            trafficAuthority,
            trafficAuthorityObj,
            publicInPrivateObj,
            thirdPartyPayerObj,
            defenceDataObj
        );

        patientDetails = cleanUpDataObj.patientDetails;
        insuranceDetails = cleanUpDataObj.insuranceDetails;
        workerCompensation = cleanUpDataObj.wcData;
        workerCompensationObj = cleanUpDataObj.wcObj;
        trafficAuthority = cleanUpDataObj.tacData;
        trafficAuthorityObj = cleanUpDataObj.tacObj;
        publicInPrivateObj = cleanUpDataObj.pipObj;
        thirdPartyPayerObj = cleanUpDataObj.tppObj;
        defenceDataObj = cleanUpDataObj.defObj;

        await createPatient();
    };

    const createPatient = async () => {
        if (isCreatingPatientEncounter) return;

        if (await _checkInputFieldsValid()) {
            isCreatingPatientEncounter = true;

            _updatePatientInsuranceDetails();

            if (patientDetails.title == "Title") patientDetails.title = 20;

            if (patientDetails.medicareRefNo)
                patientDetails.medicareRefNo = Number(
                    patientDetails.medicareRefNo,
                );
            else patientDetails.medicareRefNo = null;

            if (!patientDetails.alternativeFirstName)
                patientDetails.alternativeFirstName = "";
            if (!patientDetails.alternativeLastName)
                patientDetails.alternativeLastName = "";

            if (!patientEncounterDetails.scheduledTime)
                patientEncounterDetails.scheduledTime = "00:00:00";
            else if (
                patientEncounterDetails.scheduledTime.split(":").length < 3
            )
                patientEncounterDetails.scheduledTime += ":00";

            if (patientEncounterDetails.scheduledDate)
                patientEncounterDetails.scheduledDate =
                    patientEncounterDetails.scheduledDate.split("T")[0] +
                    "T" +
                    patientEncounterDetails.scheduledTime;

            if (!patientEncounterDetails.dischargeTime)
                patientEncounterDetails.dischargeTime = "00:00:00";
            else if (
                patientEncounterDetails.dischargeTime.split(":").length < 3
            )
                patientEncounterDetails.dischargeTime += ":00";

            if (patientEncounterDetails.dischargeDate)
                patientEncounterDetails.dischargeDate =
                    patientEncounterDetails.dischargeDate.split("T")[0] +
                    "T" +
                    patientEncounterDetails.dischargeTime;
           
            await checkPatientProcess(patientDetails);
        } else {
            showSaveWithoutValidations = true;
        }
    };

    const checkPatientProcess = async (pd) => {
        if (!pd.medicareNo) pd.medicareNo = "";
        if (!pd.membershipNo) pd.membershipNo = "";

        isHealthFundFailed = false;

        await createProcess(pd);
    };

    const createProcess = async (pd) => {
        let isPatientCreated = false;

        if (pd.id)
            await apiMethods.putMethod
                .updatePatient(pd)
                .then(async (res) => {
                    if (res.id) {
                        patientDetails = { ...res };
                        if (isValidPatientContact) await updatePatientContact();
                        _updatePatientEncounterDetails(res);
                        isPatientCreated = true;
                    } else showError(res.error);
                })
                .catch((err) => {
                    isCreatingPatientEncounter = false;
                    showError(err);
                });
        else
            await apiMethods.postMethod
                .createPatient(pd)
                .then(async (res) => {
                    if (res.id) {
                        patientDetails.id = res.id;
                        if (isValidPatientContact) await updatePatientContact();
                        _updatePatientEncounterDetails(res);
                        isPatientCreated = true;
                    } else showError(res.error);
                })
                .catch((err) => {
                    isCreatingPatientEncounter = false;
                    showException(err);
                });

        if (isPatientCreated) createPatientEncounter();
    };

    const createPatientEncounter = async () => {
        const encounterHasNotes = patientEncounterDetails.notes.length > 0;

        let encounterNotes;

        if (encounterHasNotes) {
            encounterNotes = patientEncounterDetails.notes;
            delete patientEncounterDetails.notes;
        }

        await apiMethods.postMethod
            .createPatientEncounter(patientEncounterDetails)
            .then(async (res) => {
                if (res.id) {
                    updatePatientEncounterDetails(res);
                    updatePatientDetails(patientDetails);
                    if (isEnterFromCalendar) goBack();
                    else if (isViewInDailyCalendarSidePanel)
                        calendarSidePanelProps.afterSaveEncounter();
                    else if (isCreateFromCalendarEvent) {
                        if(params.onCloseFunction)
                            params.onCloseFunction();
                    }
                    else {
                        if (encounterHasNotes)
                            await createEncounterNotes(encounterNotes, res.id);

                        if (
                            patientDetails.insuranceType !=
                                DirectInsuranceType.Private &&
                            patientDetails.insuranceType !=
                                DirectInsuranceType.SelfInsured
                        )
                            goToURL(`/PatientEncounter/view/${res.id}`);

                        const opvContainsReciprocalHealthCareAgreement =
                            await checkOpvContainsReciprocalHealthCareAgreement(
                                res.id,
                            );

                        if (!opvContainsReciprocalHealthCareAgreement)
                            goToURL(`/PatientEncounter/view/${res.id}`);
                        else {
                            patientEncounterDetails = { ...res };
                            _openReciprocalHealthCareAgreementModal();
                        }
                    }
                } else {
                    showError(res.error);
                }
            })
            .catch((err) => showException(err));

        isCreatingPatientEncounter = false;
    };

    const createEncounterNotes = async (notes, encounterID) => {
        await apiMethods.postMethod
            .createNote({
                relTo: NoteTypes.PatientEncounter,
                relId: encounterID,
                content: notes,
                visibleToDoctors: true,
            })
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to create encounter notes, please refresh the page and try again and contact support if the issue persists.",
                    );
            })
            .catch((err) => showError(err));
    };

    const updatePatientContact = async () => {
        if (!patientContactDetails.id) await _addPatientContact();
        else _editPatientContact();
    };

    const updateInsuranceTypeToOverseas = async () => {
        isChangingInsuranceTypeToOverseas = true;

        patientDetails = {
            ...patientDetails,
            insuranceType: DirectInsuranceType.Overseascover,
            insurance: "",
        };

        await apiMethods.putMethod
            .updatePatient(patientDetails)
            .then(async (res) => {
                if (res.id) {
                    _updatePatientEncounterDetails(res);
                    await apiMethods.putMethod
                        .updatePatientEncounter(patientEncounterDetails, false, "Update insurance to overseas")
                        .catch((err) => showException(err));
                } else showError(res.error);
            })
            .catch((err) => {
                showError(err);
            });

        isChangingInsuranceTypeToOverseas = false;

        _closeReciprocalHealthCareAgreementModal();
    };

    const clearCurrentAdminSelectedAccount = () => {
        adminSelectedAccount.selectedAccount = null;
    };

    const updateSuggestion = async (res) => {
        isShowOverrideModal = false;

        const {
            suggestedMedicareNum,
            suggestedMedicareReference,
            suggestedName,
            suggestedLastName,
            suggestedBirthdate,
            suggestedInsuranceId,
        } = res;

        if (suggestedMedicareNum)
            patientDetails.medicareNo = suggestedMedicareNum;

        if (suggestedMedicareReference)
            patientDetails.medicareRefNo = suggestedMedicareReference;

        if (suggestedName) patientDetails.firstName = suggestedName;

        if (suggestedLastName) patientDetails.lastName = suggestedLastName;

        if (suggestedBirthdate) patientDetails.birthDate = suggestedBirthdate;

        if (suggestedInsuranceId)
            patientDetails.insuranceId = suggestedInsuranceId;

        isOpvSuggestionsAttempt = true;

        await createPatient();

        return;
    };

    const openOverrideModal = () => {
        isShowOverrideModal = true;
    };

    const closeOverrideModal = () => {
        isShowOverrideModal = false;
        isCreatingPatientEncounter = false;
        isOpvSuggestionsAttempt = false;
        isHealthFundFailed = false;
    };

    const onHospitalChange = ({ detail }) => {
        if (detail?.id) _syncProviderWithHospital(detail);
    };

    const showDotActionsMenu = () => {
        if (document.getElementById("encounterActionMenu"))
            document.getElementById("encounterActionMenu").style.display =
                "flex";
    };

    const hideDotActionsMenu = () => {
        if (document.getElementById("encounterActionMenu"))
            document.getElementById("encounterActionMenu").style.display =
                "none";
    };

    // HELPER FUNCTIONS
    const _syncProviderWithHospital = (hospital) => {
        const { id: hospitalId } = hospital;

        const doctorProvidersArr = $loggedInDoctorDetail.providers;

        if (!doctorProvidersArr.length) return;

        const relatedProvider = doctorProvidersArr.find(
            ({ hospitals }) =>
                hospitals &&
                hospitals.length &&
                hospitals.some((hospital) => hospital.hospitalId == hospitalId),
        );

        if (relatedProvider) {
            selectedDoctorProvider.details = { ...relatedProvider, selectLabel: `${relatedProvider.number}${relatedProvider.location ? ` (${relatedProvider.location})` : ""}` };
            if (
                relatedProvider.hospitals?.length &&
                patientDetails.insuranceType ==
                    DirectInsuranceType.PublicInPrivate
            ) {
                const pipHospital = relatedProvider.hospitals.find(
                    (h) => h.hospitalId == hospitalId,
                );
                if (pipHospital)
                    publicInPrivateObj.vendorNumbers =
                        pipHospital.pipVendorNumber ?? "";
            }
        } else {
            //no provider related to this hospital, set the default one
            var defaultOne = $loggedInDoctorDetail.providers.find((p) => p.isDefault);
            selectedDoctorProvider.details = { 
                ...defaultOne,
                selectLabel: `${defaultOne.number}${defaultOne.location ? ` (${defaultOne.location})` : ""}`
            };
        }
    };

    const _updatePatientInsuranceDetails = () => {
        const { insuranceType } = patientDetails;

        if (patientDetails.insurance) delete patientDetails.insurance;
        if (patientDetails.insuranceId) delete patientDetails.insuranceId;
        if (patientDetails.membershipNo) delete patientDetails.membershipNo;

        switch (insuranceType) {
            case 0: // Private
                if (insuranceDetails.insuranceFund)
                    patientDetails.insuranceId =
                        insuranceDetails.insuranceFund.id;
                else delete patientDetails.insuranceId;
                patientDetails.membershipNo = insuranceDetails.membershipNo;
                patientDetails.membershipRefNo =
                    insuranceDetails.membershipRefNo
                        ? Number(insuranceDetails.membershipRefNo)
                        : null;
                if (insuranceDetails.privateCoverType)
                    patientDetails.insurance =
                        insuranceDetails.privateCoverType;
                break;
            case 10: // Overseas cover
                patientDetails.insurance = insuranceDetails.overseasCover;
                patientDetails.membershipNo = insuranceDetails.membershipNo;
                patientDetails.membershipRefNo =
                    insuranceDetails.membershipRefNo
                        ? Number(insuranceDetails.membershipRefNo)
                        : null;
                if (insuranceDetails.insuranceFund)
                    patientDetails.insuranceId =
                        insuranceDetails.insuranceFund.id;
                break;
            case 11: // Self insured
            case 15: // Cosmetic
                break;
            case 16: // Workers Comp
                patientDetails.insurance = `${
                    insuranceDetails.employer || ""
                } | ${insuranceDetails.employerEmail || ""} | ${
                    workerCompensationObj.claimNumber || ""
                }`;

                if (insuranceDetails.employer && workerCompensation)
                    workerCompensation.employer = insuranceDetails.employer;

                if (insuranceDetails.employerEmail && workerCompensation)
                    workerCompensation.employerEmail =
                        insuranceDetails.employerEmail;
                break;
            case 17: // Traffic accident
                patientDetails.insurance = `${trafficAuthorityObj.claimNumber ? trafficAuthorityObj.claimNumber : ""}`;
                break;
            case 20: // DVA
                patientDetails.insurance = `${insuranceDetails.dvaNumber}`;
                break;
            case 25: // Defence BUPA
            case 26: // Defence AMA
                patientDetails.insurance = `${defenceDataObj.pid ?? insuranceDetails.pidNumber} | ${defenceDataObj.dan ?? insuranceDetails.danNumber}`;
                break;
            case 30: // Public in Private
                patientDetails.insurance = `${
                    publicInPrivateObj.email ?? ""
                } | ${publicInPrivateObj.vendorNumbers ?? ""}`;
                break;
            default:
                break;
        }
    };

    const _updatePatientEncounterDetails = (res) => {
        patientDetails = { ...res };

        patientEncounterDetails = {
            ...patientEncounterDetails,
            patient: { id: res.id },
            doctor: { id: $loggedInDoctorDetail.id },
            surgeon: !selectedSurgeon.details
                ? { id: 0 }
                : {
                      id: selectedSurgeon.details.id,
                      providerUniqueId:
                          selectedSurgeon.details.providerUniqueId,
                  },
            hospital: !selectedHospital.details
                ? { id: 0 }
                : { id: selectedHospital.details.id },
            doctorProvider: !selectedDoctorProvider.details
                ? null
                : {
                      number: selectedDoctorProvider.details.number,
                  },
            patientAddress: res.address,
            patientEmail: res.email,
            patientPhone: res.phone,
            patientCountry: res.country,
            patientState: res.state,
            patientCity: res.city,
            patientPostCode: res.postCode,
        };

        if (patientDetails.insuranceType == 16) {
            if (workerCompensation?.id)
                patientEncounterDetails.patientEncounterWorkCoverData = {
                    workCoverAuthority: workerCompensation?.id ?? 0,
                    email: workerCompensationObj?.insurerEmail
                        ? workerCompensationObj.insurerEmail
                        : workerCompensation.email,
                    claimId: workerCompensationObj?.claimNumber ?? "",
                    employer: insuranceDetails.employer ?? "",
                    employerEmail: insuranceDetails.employerEmail ?? "",
                };
        } else if (
            patientEncounterDetails.patientEncounterWorkCoverData
                ?.workCoverAuthority
        )
            delete patientEncounterDetails.patientEncounterWorkCoverData;

        if (patientDetails.insuranceType == 17) {
            if (trafficAuthority?.id)
                patientEncounterDetails.patientEncounterTrafficAccidentData = {
                    trafficAccidentAuthority: trafficAuthority.id,
                    email: trafficAuthorityObj?.email
                        ? trafficAuthorityObj.email
                        : trafficAuthority.email,
                    claimId: trafficAuthorityObj.claimNumber,
                };
        } else if (
            patientEncounterDetails.patientEncounterTrafficAccidentData
                ?.trafficAccidentAuthority
        )
            delete patientEncounterDetails.patientEncounterTrafficAccidentData;

        if (patientDetails.insuranceType == 18) {
            patientEncounterDetails.patientEncounterThirdPartyInsurerData = {
                ...thirdPartyPayerObj,
            };
        } else
            delete patientEncounterDetails.patientEncounterThirdPartyInsurerData;

        if (patientDetails.insuranceType == 30) {
            patientEncounterDetails.patientEncounterPIPData = {
                email: publicInPrivateObj.email ? publicInPrivateObj.email : "",
                vendorNumbers: publicInPrivateObj.vendorNumbers
                    ? publicInPrivateObj.vendorNumbers
                    : "",
            };
        } else if (patientEncounterDetails.patientEncounterPIPData?.email)
            delete patientEncounterDetails.patientEncounterPIPData;

        if (
            patientDetails.insuranceType === DirectInsuranceType.DefenceBupa ||
            patientDetails.insuranceType === DirectInsuranceType.DefenceAMA
        ) {
            patientEncounterDetails.patientEncounterDefenceData = {
                ...defenceDataObj
            };
        } else {
            delete patientEncounterDetails.patientEncounterDefenceData;
        }
    };

    const _checkInputFieldsValid = async () => {
        errorFields = [];

        await _updateInvalidFieldsStyle();

        return errorFields.length == 0;
    };

    const _updateInvalidFieldsStyle = async () => {
        if (!selectedDoctorProvider.details) {
            errorFields = addErrorInput("doctorProviderContainer", errorFields);
            errorFields = addErrorInput(
                "doctorProviderContainer",
                errorFields,
                "Doctor provider",
            );
        }

        const patientDetailsCheck =
            await patientSectionRef.checkPatientDetailsValidation();

        if (patientDetailsCheck.length)
            errorFields = [...errorFields, ...patientDetailsCheck];

        if(patientContactRef) {
            const patientContactCheck =
                await patientContactRef.checkPatientContactValidation();

            if (patientContactCheck.length)
                errorFields = [...errorFields, ...patientContactCheck];
        }

        const procedureDetailsCheck =
            await procedureDetailsRef.checkProcedureDetailsValidation();

        if (procedureDetailsCheck.length)
            errorFields = [...errorFields, ...procedureDetailsCheck];

        const insuranceDetailsCheck =
            await insuranceDetailsRef.checkInsuranceDetailsValidation(
                patientDetails,
            );

        if (insuranceDetailsCheck.length)
            errorFields = [...errorFields, ...insuranceDetailsCheck];

        // const surgeonDetailsCheck =
        //     await surgeonDetailsRef.checkSurgeonDetailsValidation();

        // if (surgeonDetailsCheck.length)
        //     errorFields = [...errorFields, ...surgeonDetailsCheck];

        if (errorFields.length) {
            const scrollToElement = document.getElementById(errorFields[0]);
            if (scrollToElement)
                scrollToElement.scrollIntoView({ behavior: "smooth" });
        }
    };

    const _handleOPVSuggestions = async (res) => {
        if (res.error) showError(res.error);
        else {
            const validSuggestions =
                res.suggestedMedicareNum ||
                res.suggestedMedicareReference ||
                res.suggestedName ||
                res.suggestedLastName ||
                res.suggestedBirthdate ||
                res.suggestedInsuranceId;

            if (validSuggestions && !isOpvSuggestionsAttempt) {
                updateSuggestion(res);
                return;
            }

            // !validSuggestions || (validSuggestions && isOpvSuggestionsAttempt)
            if (patientDetails.insuranceType == 11)
                if (!validSuggestions)
                    // check ONLY medicare
                    await checkPatientProcess(patientDetails);
                else openOverrideModal();
            else {
                // check BOTH medicare && healthFund
                if (res.healthFundStatus <= 1) {
                    // healthFund success
                    if (!validSuggestions)
                        await checkPatientProcess(patientDetails);
                    else openOverrideModal();
                } else {
                    // healthFund failed
                    isHealthFundFailed = true;
                    openOverrideModal();
                }
            }
        }
    };

    const _addPatientContact = async () => {
        await apiMethods.postMethod
            .createPatientContact({
                ...patientContactDetails,
                patientId: patientDetails.id,
            })
            .catch((err) => showException(err));
    };

    const _editPatientContact = async () => {
        await apiMethods.putMethod
            .updatePatientContact(patientContactDetails)
            .catch((err) => showException(err));
    };

    const _checkPatientContactValidation = (contact = {}) => {
        return (
            contact.name ||
            contact.relationship ||
            contact.email ||
            contact.phone
        );
    };

    const _handleKeyboardPress = (e) => {
        if (!e) return;

        const { key } = e;

        if (
            !key ||
            key.toLowerCase() != "enter" ||
            !adminSelectedAccount.selectedAccount
        )
            return;

        adminGoToCreatePatientEncounter();
    };

    const _openReciprocalHealthCareAgreementModal = () =>
        (reciprocalHealthCareAgreementNotificationModalOpen = true);

    const _closeReciprocalHealthCareAgreementModal = () => {
        reciprocalHealthCareAgreementNotificationModalOpen = false;
        if (
            patientEncounterDetails.hasOwnProperty("id") &&
            patientEncounterDetails.id
        )
            goToURL(`/PatientEncounter/view/${patientEncounterDetails.id}`);
    };
</script>

{#if isLoading}
    <PageLoading />
{:else if showSelectAccountPhase}
    <div
        class="flex flex-col h-full flex-1 items-center justify-center gap-y-4"
    >
        <div class="flex gap-x-4 items-center w-3/5">
            <p>Select account:</p> 

            <Select
                bind:value={adminSelectedAccount.selectedAccount}
                class="flex flex-1 max-h-[35px] rounded-full"
                loadOptions={loadAccounts}
                itemId="key"
                label="value"
                on:clear={clearCurrentAdminSelectedAccount}
                noOptionsMessage="No account found"
                placeholder="Account"
                focused
            >
                <div slot="item" let:item>
                    <div title={`User ID: ${item.key}`}>
                        {item.value}
                    </div>
                </div>
            </Select>
        </div>

        <Button
            clickFunc={adminGoToCreatePatientEncounter}
            isDisabled={!adminSelectedAccount.selectedAccount}
        >
            Next step
        </Button>
    </div>
{:else}
    <div class="flex-1 flex mt-4 w-full">
        <form class="flex flex-col flex-1 gap-y-4 overflow-y-auto">
            <div class="flex flex-1 w-full items-center justify-end">
                <div class="flex items-center gap-x-2">
                    {#if showSaveWithoutValidations} 
                        <Button
                            clickFunc={() => {
                                overrideValidation = true;
                                removeIrrelevantFields();
                            }}
                            isDisabled={isCreatingPatientEncounter}
                            defaultClass="btn btn-sm btn-error text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                            manualClass={isCreatingPatientEncounter
                                ? "loading"
                                : ""}
                        >
                            {isCreatingPatientEncounter ? "Saving" : "Save with invalid fields"}
                        </Button>
                    {/if}
                    <Button
                        clickFunc={() => {
                            overrideValidation = false;
                            removeIrrelevantFields();
                        }}
                        isDisabled={isCreatingPatientEncounter}
                        defaultClass="btn btn-sm btn-secondary text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                        manualClass={isCreatingPatientEncounter
                            ? "loading"
                            : ""}
                    >
                        {isCreatingPatientEncounter ? "Saving" : "Save"}
                    </Button>
                   </div>
            </div>

            <PatientDetailsSection
                bind:this={patientSectionRef}
                bind:patientDetails
                bind:patientContactDetails
                bind:insuranceDetails
                bind:workerCompensation
                bind:workerCompensationObj
                bind:trafficAuthority
                bind:trafficAuthorityObj
                bind:publicInPrivateObj
                bind:thirdPartyPayerObj
                {insuranceDetailsRef}
                {overrideValidation}
                isFromCreate
            />

            <ProcedureDetailsSection
                bind:this={procedureDetailsRef}
                bind:patientEncounterDetails
                bind:selectedSurgeon
                bind:selectedHospital
                bind:createSurgeonFilters
                on:onHospitalChange={onHospitalChange}
                typeOfBill={patientEncounterDetails.typeOfBill}
                isFromCreate
                {overrideValidation}
                {insuranceDetailsRef}
                on:encounterTypeChange={() =>
                    (patientDetails = syncLabourEpiduralPatientTitleAndGender(
                        patientEncounterDetails,
                        patientDetails,
                    ))}
            />

            <InsuranceDetailsSection
                bind:this={insuranceDetailsRef}
                bind:patientDetails
                bind:patientEncounterDetails
                bind:insuranceDetails
                bind:workerCompensation
                bind:workerCompensationObj
                bind:trafficAuthority
                bind:trafficAuthorityObj
                bind:publicInPrivateObj
                bind:thirdPartyPayerObj
                bind:defenceDataObj
                bind:selectedDoctorProvider
                bind:createSurgeonFilters
                {selectedHospital}
                {overrideValidation}
                isFromCreate
            />

            <CardLayout title="Optional fields" cardClass="p-1 pb-4" enableCollapse={true} defaultExpanded={false}>
                <PreOpDetailsSection
                    bind:this={preOpDetailsRef}
                    isFromCreate
                    bind:patientEncounterDetails
                />
                <PatientContactSection
                    bind:this={patientContactRef}
                    bind:patientContactDetails
                    bind:patientEncounterDetails
                    {overrideValidation}
                />
                <NotesDetailsSection bind:patientEncounterDetails />
                <OtherDetailsSection
                    bind:patientEncounterDetails
                    bind:patientDetails
                    {overrideValidation}
                />
            </CardLayout>

            <div class="flex flex-row gap-x-2">
                <Button
                    clickFunc={() => {
                        overrideValidation = false;
                        removeIrrelevantFields();
                    }}
                    isDisabled={isCreatingPatientEncounter}
                    defaultClass="btn btn-sm btn-secondary text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                    manualClass={isCreatingPatientEncounter ? "loading" : ""}
                >
                    {isCreatingPatientEncounter ? "Saving" : "Save"}
                </Button>
                {#if showSaveWithoutValidations}
                    <Button
                        clickFunc={() => {
                            overrideValidation = true;
                            removeIrrelevantFields();
                        }}
                        isDisabled={isCreatingPatientEncounter}
                        defaultClass="btn btn-sm btn-error text-white text-sm flex-none border-none w-auto h-10 min-w-[200px] mx-2"
                        manualClass={isCreatingPatientEncounter
                            ? "loading"
                            : ""}
                    >
                        {isCreatingPatientEncounter ? "Saving" : "Save with invalid fields"}
                    </Button>
                {/if}
            </div>
        </form>
    </div>
{/if}

<div class={isShowOverrideModal ? "modal modal-open sm:modal-middle" : "modal"}>
    <div class="modal-box">
        <h3 class="font-medium text-lg">Warning:</h3>
        <div class="p-4">
            <p class="leading-6 text-error">
                {isHealthFundFailed
                    ? "OPV Health Fund failed for patient. Create anyway?"
                    : "OPV failed for patient. Create anyway?"}
            </p>
        </div>
        <div class="modal-action flex justify-around gap-x-4">
            <button
                class="btn btn-secondary text-white btn-sm border-none w-48"
                on:click={closeOverrideModal}>Close</button
            >

            <button
                class="btn btn-error text-white btn-sm border-none w-48"
                on:click={() => checkPatientProcess(patientDetails)}
            >
                Continue anyway
            </button>
        </div>
    </div>
</div>

<NotificationModal
    isModalOpen={reciprocalHealthCareAgreementNotificationModalOpen}
    title="Reciprocal Health Care Agreement"
    closeModal={_closeReciprocalHealthCareAgreementModal}
    closeModalFunction={_closeReciprocalHealthCareAgreementModal}
    confirmAction={updateInsuranceTypeToOverseas}
    cancelText="Cancel"
    submitText={isChangingInsuranceTypeToOverseas
        ? "Changing"
        : "Change Insurance"}
    isConfirming={isChangingInsuranceTypeToOverseas}
>
    <div class="flex flex-col gap-y-2 p-">
        <p>
            The patient is or was covered under the Reciprocal Health Care
            Agreement. Although these encounters may pass OPV, they generally
            cannot be submitted via Eclipse.
        </p>
        <p>
            It is recommended to change the insurance type to "Overseas" and
            either charge the patient a total fee or manually submit the claim
            to the insurer.
        </p>
        <p>
            Do you wish to proceed with changing the insurance type to
            "Overseas"?
        </p>
    </div>
</NotificationModal>
